// extracted by mini-css-extract-plugin
export default {"root":"PremiumLimitPreview-module__root","title":"PremiumLimitPreview-module__title","description":"PremiumLimitPreview-module__description"};